import { DELETE_CONTENT_OR_FOLDER_SUCCESS } from 'app/UserInfo/const';

import {
  FILTER_ADDED,
  FILTER_DELETED,
  FILTERS_SET,
  SEARCH_CONTEXT_CLEARED,
  SEARCH_RESULTS_CLEARED,
  SEARCH_RESULTS_FULFILLED,
  SEARCH_RESULTS_REJECTED,
  SEARCH_RESULTS_REQUESTED,
  SEARCH_SUGGESTIONS_FULFILLED,
  SEARCH_SUGGESTIONS_REJECTED,
  SEARCH_SUGGESTIONS_REQUESTED,
  SEARCH_STORE_PAGE_NUM,
  SEARCH_STORE_CONTEXT
} from './const';

export const defaultState = {
  filters: [],
  results: [],
  suggestions: [],
  suggestionsLoading: false,
  resultsLoading: false,
  currPageNum: 1,
  pageNumStart: 1
};

/**
 * handle state updates for a particular search context
 * @param {object} state - the current state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
export const innerReducer = function innerSearchReducer(state, action) {
  switch (action.type) {
    case FILTER_ADDED:
      // do nothing if filter was already added
      return state.filters.some(f => f.k === action.filter.k && f.v === action.filter.v)
        ? state
        : {
            ...state,
            filters: [...state.filters, action.filter]
          };
    case FILTER_DELETED:
      // return only filters that don't match the action
      return {
        ...state,
        filters: state.filters.filter(f => f.k !== action.filter.k || f.v !== action.filter.v)
      };
    case FILTERS_SET:
      return {
        ...state,
        filters: action.filters
      };
    case SEARCH_CONTEXT_CLEARED:
      return defaultState;
    case SEARCH_RESULTS_CLEARED:
      return { ...state, results: [] };
    case SEARCH_STORE_PAGE_NUM:
      return {
        ...state,
        currPageNum: action.payload.pageNum,
        pageNumStart: action.payload.pageNumStart
      };
    case SEARCH_RESULTS_FULFILLED:
      return {
        ...state,
        results: action.payload,
        resultsLoading: false
      };
    case SEARCH_RESULTS_REJECTED:
      return {
        ...state,
        resultsLoading: false
      };
    case SEARCH_RESULTS_REQUESTED:
      return {
        ...state,
        resultsLoading: true
      };
    case SEARCH_SUGGESTIONS_FULFILLED:
      return {
        ...state,
        suggestionsLoading: false,
        suggestions: action.payload
      };
    case SEARCH_SUGGESTIONS_REJECTED:
      return {
        ...state,
        suggestionsLoading: false
      };
    case SEARCH_SUGGESTIONS_REQUESTED:
      return {
        ...state,
        suggestionsLoading: true
      };
    default:
      return state;
  }
};

/**
 * search reducer that supports multiple search instances
 * @param {object} state - the current search state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
const reducer = function searchReducer(state = {}, action = {}) {
  switch (action.type) {
    case DELETE_CONTENT_OR_FOLDER_SUCCESS: {
      const objKeys = Object.keys(state);
      const filteredResults = {};
      objKeys.forEach(key => {
        filteredResults[key] = state[key].results
          ? {
              ...state[key],
              results: state[key].results.filter(j => j.Id !== action.contentId)
            }
          : state[key];
      });
      return filteredResults;
    }
    case SEARCH_STORE_CONTEXT: {
      return {
        ...state,
        context: action.context
      };
    }
    default: {
      // skip falsy and missing context actions
      if (!action || !action.context) {
        return state;
      }

      // pass state for context specified in action to inner reducer and overwrite existing context
      const { context } = action;
      const contextState = state[context] || defaultState;

      // always return the current search context within state
      return {
        ...state,
        context,
        [action.context]: innerReducer(contextState, action)
      };
    }
  }
};

export default reducer;
